{
  "dependencies": {
    "@aws-sdk/client-cognito-identity-provider": "^3.848.0",
    "@expo-google-fonts/inter": "^0.3.0",
    "@expo/html-elements": "^0.11.2",
    "@expo/vector-icons": "^14.1.0",
    "@gluestack-ui/accordion": "^1.0.14",
    "@gluestack-ui/actionsheet": "^0.2.53",
    "@gluestack-ui/alert": "^0.1.16",
    "@gluestack-ui/alert-dialog": "^0.1.38",
    "@gluestack-ui/avatar": "^0.1.18",
    "@gluestack-ui/button": "^1.0.14",
    "@gluestack-ui/checkbox": "^0.1.39",
    "@gluestack-ui/divider": "^0.1.10",
    "@gluestack-ui/fab": "^0.1.28",
    "@gluestack-ui/form-control": "^0.1.19",
    "@gluestack-ui/icon": "^0.1.27",
    "@gluestack-ui/image": "^0.1.17",
    "@gluestack-ui/input": "^0.1.38",
    "@gluestack-ui/link": "^0.1.29",
    "@gluestack-ui/menu": "^0.2.43",
    "@gluestack-ui/modal": "^0.1.41",
    "@gluestack-ui/nativewind-utils": "^1.0.26",
    "@gluestack-ui/overlay": "^0.1.16",
    "@gluestack-ui/popover": "^0.1.49",
    "@gluestack-ui/pressable": "^0.1.23",
    "@gluestack-ui/progress": "^0.1.18",
    "@gluestack-ui/radio": "^0.1.40",
    "@gluestack-ui/select": "^0.1.31",
    "@gluestack-ui/slider": "^0.1.32",
    "@gluestack-ui/spinner": "^0.1.15",
    "@gluestack-ui/switch": "^0.1.29",
    "@gluestack-ui/textarea": "^0.1.25",
    "@gluestack-ui/toast": "^1.0.9",
    "@gluestack-ui/tooltip": "^0.1.44",
    "@hookform/resolvers": "^5.0.1",
    "@legendapp/motion": "^2.4.0",
    "@react-native-async-storage/async-storage": "1.23.1",
    "@react-native-picker/picker": "2.9.0",
    "@react-navigation/bottom-tabs": "^7.2.0",
    "@react-navigation/drawer": "^7.1.1",
    "@react-navigation/native": "^7.0.14",
    "@sentry/react-native": "~6.10.0",
    "@tanstack/react-query": "^5.75.1",
    "@transifex/native": "^7.1.3",
    "@transifex/react": "^7.1.3",
    "@unitools/link": "^0.0.4",
    "@unitools/router": "^0.0.6",
    "aws-cdk-lib": "^2.206.0",
    "axios": "^1.9.0",
    "expo": "~52.0.46",
    "expo-blur": "~14.0.3",
    "expo-camera": "~16.0.18",
    "expo-constants": "~17.0.8",
    "expo-font": "~13.0.4",
    "expo-haptics": "~14.0.1",
    "expo-image": "~2.0.7",
    "expo-linking": "~7.0.5",
    "expo-location": "~18.0.10",
    "expo-router": "~4.0.21",
    "expo-screen-orientation": "~8.0.4",
    "expo-secure-store": "~14.0.1",
    "expo-splash-screen": "~0.29.24",
    "expo-status-bar": "~2.0.1",
    "expo-symbols": "~0.2.2",
    "expo-system-ui": "~4.0.9",
    "expo-web-browser": "~14.0.2",
    "fflate": "^0.8.2",
    "ipctg-inflow-types": "bitbucket:ipc-technology-group/ipctg-inflow-types#master",
    "jws": "^4.0.0",
    "nativewind": "4.1.23",
    "react": "18.3.1",
    "react-dom": "18.3.1",
    "react-hook-form": "^7.56.1",
    "react-native": "0.76.9",
    "react-native-css-interop": "^0.1.22",
    "react-native-gesture-handler": "~2.20.2",
    "react-native-get-random-values": "^1.11.0",
    "react-native-markdown-display": "~7.0.2",
    "react-native-qrcode-svg": "^6.3.15",
    "react-native-reanimated": "~3.16.1",
    "react-native-safe-area-context": "4.12.0",
    "react-native-screens": "~4.4.0",
    "react-native-svg": "15.8.0",
    "react-native-uuid": "^2.0.3",
    "react-native-web": "~0.19.13",
    "react-native-webview": "13.12.5",
    "tailwindcss": "^3.4.17",
    "zod": "^3.24.3",
    "zustand": "^5.0.4"
  },
  "devDependencies": {
    "@babel/core": "^7.26.10",
    "@babel/plugin-transform-class-static-block": "^7.26.0",
    "@biomejs/biome": "1.9.4",
    "@testing-library/react-native": "^13.2.0",
    "@transifex/cli": "^7.1.3",
    "@types/jest": "^29.5.14",
    "@types/react": "~18.3.12",
    "@types/uuid": "^10.0.0",
    "babel-plugin-module-resolver": "^5.0.2",
    "babel-plugin-transform-define": "^2.1.4",
    "expo-atlas": "^0.4.0",
    "expo-dev-client": "~5.0.19",
    "jest": "^29.7.0",
    "jest-expo": "~52.0.6",
    "jest-sonar-reporter": "^2.0.0",
    "sonarqube-scanner": "^4.3.0",
    "ts-node": "^10.9.2",
    "typescript": "^5.8.3"
  },
  "engines": {
    "node": "^16 || ^18 || ^20 || ^22"
  },
  "expo": {
    "doctor": {
      "reactNativeDirectoryCheck": {
        "listUnknownPackages": false
      }
    }
  },
  "jestSonar": {
    "reportPath": "test-reports",
    "reportFile": "jest-sonar.xml"
  },
  "main": "index.js",
  "name": "ipctg-park-app",
  "private": true,
  "scripts": {
    "biome:check": "biome check",
    "biome:checkfix": "biome check --fix --unsafe",
    "biome:format": "biome format",
    "biome:lint": "biome lint",
    "build": "npx expo@latest prebuild --clean --no-install",
    "build:android": "npm run build -- --platform android && cd android && ./gradlew assemble && cd ..",
    "build:android:debug": "npm run build -- --platform android && cd android && ./gradlew assembleDebug && cd ..",
    "build:android:debug:install": "npm run build -- --platform android && cd android && ./gradlew installDebug && cd ..",
    "build:android:release": "npm run build -- --platform android && cd android && ./gradlew assembleRelease && cd ..",
    "build:android:release:install": "npm run build -- --platform android && cd android && ./gradlew installRelease && cd ..",
    "build:ios": "npm run build -- --platform ios",
    "build:web": "npm run static:web",
    "dev": "expo start --clear --go",
    "dev:android": "npm run dev -- --android",
    "dev:ios": "npm run dev -- --ios",
    "dev:native": "expo start --clear --dev-client",
    "dev:native:android": "npm run dev:native -- --android",
    "dev:native:ios": "npm run dev:native -- --android",
    "dev:web": "npm run dev -- --web",
    "doctor": "npx expo-doctor@latest",
    "push:transifex": "txjs-cli push src --secret=\"$TRANSIFEX_SECRET\" --token=\"$EXPO_PUBLIC_TRANSIFEX_TOKEN\" --purge",
    "run:android": "expo run:android",
    "sonar:scan": "sonar-scanner",
    "start": "expo start --clear --go --minify --no-dev",
    "start:android": "npm run start -- --android",
    "start:ios": "npm run start -- --ios",
    "start:native": "expo start --clear --dev-client --minify --no-dev",
    "start:native:android": "npm run start:native -- --android",
    "start:native:ios": "npm run start:native -- --ios",
    "start:web": "npm run start -- --web",
    "static": "expo export --clear",
    "static:android": "npm run static -- --platform android",
    "static:ios": "npm run static -- --platform ios",
    "static:web": "npm run static -- --platform web",
    "test": "jest --collectCoverage=false",
    "test:cov": "jest",
    "test:dev": "jest --collectCoverage=false --watchAll",
    "update:expo": "npx expo@latest install --fix",
    "update:gluestack": "npx gluestack-ui@latest add --all --path ./src/components/ui/",
    "update:types": "npm i ipctg-inflow-types",
    "android": "expo run:android",
    "ios": "expo run:ios",
    "check:deploy": "npx tsx ./cdk/lib/check-deploy.ts"
  },
  "version": "1.0.15"
}
